import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
@Component({
  selector: 'app-uploadphoto',
  templateUrl: './uploadphoto.component.html',
  styleUrls: ['./uploadphoto.component.scss']
})
export class UploadphotoComponent implements OnInit {

  imageURL: string;
  uploadForm: FormGroup;
  userid: any;
  currentUser: any;
  userImgUrl: string;
  userPhotoFile: any | Blob;
  imageType: boolean;
  oversize: boolean;
  userDetails: any;
  constructor(public fb: FormBuilder, public dialogRef: MatDialogRef<UploadphotoComponent>, private authService: AuthService, private us: UserService) {
    // Reactive Form
    this.uploadForm = this.fb.group({
      avatar: [null],
      name: ['']
    })
  }

  ngOnInit(): void {
    this.authService.user.subscribe(user => this.currentUser = user);
    this.userDetails = this.currentUser;
  }
  onFileSelected(event: any, inputFrom: string) {
    const allowedExtensions = /(\.(jpg|jpeg|png|svg))$/i;
    const allowedMimetypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml'];
    const MAX_SIZE = 2 * 1024 * 1024; // 2MB

    this.userPhotoFile = event.target.files[0];
    if (!this.userPhotoFile) return;

    if (!allowedExtensions.exec(this.userPhotoFile.name) || !allowedMimetypes.includes(this.userPhotoFile.type)) {
      this.imageType = true;
      this.oversize = false;
      return;
    }
    this.imageType = false;

    if (this.userPhotoFile.size > MAX_SIZE) {
      this.oversize = true;
      return;
    }
    this.oversize = false;

    this.uploadPhoto(this.userPhotoFile);
  }
  uploadPhoto(userPhotoFile) {
    const formData = new FormData();
    formData.append('phone', this.userDetails.phone);
    formData.append('photoFile', userPhotoFile);
    this.userImgUrl = '';
    // Backend stores raster images as .jpg; SVG keeps its extension
    const isSvg = userPhotoFile.type === 'image/svg+xml';
    this.userDetails.photo = 'img' + this.userDetails.phone + (isSvg ? '.svg' : '.jpg');
    this.us.changePhoto(this.currentUser.id, formData).subscribe((res: any) => {
      this.authService.currentUserBS.next(this.userDetails);
      this.dialogRef.close({ msg: "OK" });
    });
  }

  onNoClick(): void {
    this.dialogRef.close({ msg: "NO" });
  }
}
